<!-- 综训馆扫码入口页（0928-扫码异常方案，2026-09-28；UI 按蓝湖稿 0928-扫码异常 实现）：
     教练端出码（上课码/购卡码/进场码）已改为「会员端 H5 直出链接」——微信等外部扫一扫
     打开的是会员端 H5 页面（无登录态，页面自身呈现扫码异常态并跳转到本页引导打开 APP）。
     本页职责：把用户带进 betterwe星球 APP（已装 → 拉起并定位综训馆内页；未装 → 下载）。
     双 UI 模式（按 ?sfrom= 渠道参数切换）：
     1. 不带 sfrom / 未命中 CHANNEL_BG_MAP → 默认 UI：上半白底（标题 + 副文案 +
        打开/下载双按钮横排）+ 下半设计稿切图置底；
     2. 命中渠道 → 渠道 UI：整页复刻 app-download（整页渠道背景图 + 底部固定
        「已下载直接打开 / 下载 betterWE星球APP」双按钮 + 协议入口），下载/拉起/埋点/
        美团鸿蒙中转等逻辑与 app-download 完全一致，渠道包按 sfrom 下发。 -->
<template>
  <div class="zxg-scan-entry">
    <van-overlay :show="showOpen && !isMini" @click="showOpen = false" z-index="99" :lock-scroll="false">
      <img class="ad-open" src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-share-open" alt="" />
    </van-overlay>
    <!-- 渠道 UI（sfrom 命中 CHANNEL_BG_MAP）：结构与逻辑整页复刻 app-download——
         整页渠道背景图 + 底部固定「已下载直接打开 / 下载 betterWE星球APP」双按钮 + 协议入口 -->
    <div v-if="channelBgImg" class="zxg-channel" v-pageBuried :data-page-buried="bgText">
      <div class="zxg-channel-container">
        <img class="zxg-channel-bg" :src="channelBgImg" alt="" />
        <div class="ad-tips">
          <div class="t-btn user-btn" @click="toUrl(0)">应用权限</div>
          <div class="t-line"></div>
          <div class="t-btn user-btn" @click="toUrl(1)">隐私协议</div>
        </div>
      </div>
      <div class="ad-btn ad-btn-have"
        >已下载直接打开<WxOpenLaunchApp :extinfo="toAppPath"></WxOpenLaunchApp
      ></div>
      <div class="ad-btn user-btn" @click="downloadApp" v-clickBuried :data-click-buried="clickText">
        <img
          :src="
            isAndroid
              ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-icon-android'
              : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-icon-ios'
          "
          alt=""
        />
        下载 betterWE星球APP
      </div>
    </div>
    <!-- 默认 UI（不带 sfrom / sfrom 未命中渠道）：上半（白底）标题 + 副文案（品牌橙强调
         App 名）+ 双按钮横排。「打开App」微信内由开放标签覆盖层接管点击（拉起 APP 到
         extinfo 页），微信外走 @click 的 scheme 拉起；小程序 webview 内无法拉起，不渲染该按钮 -->
    <template v-else>
      <div class="zxg-top">
        <div class="zxg-title">暂不支持在网页进行扫码</div>
        <div class="zxg-desc">
          <p>请前往<span class="zxg-app-name">betterWE星球App</span>，</p>
          <p>在【星球综训】页面使用扫一扫功能</p>
        </div>
        <div class="zxg-btns">
          <div v-if="!isMini" class="zxg-btn zxg-btn-open user-btn" @click="openApp">打开App
            <WxOpenLaunchApp type="zxg" :extinfo="toAppPath"></WxOpenLaunchApp>
          </div>
          <div class="zxg-btn zxg-btn-download user-btn" @click="downloadApp">下载App</div>
        </div>
      </div>
      <!-- 下半（切图：APP 首页 mockup + 弧形过渡橙色区 + betterWE星球 logo），宽 100% 置底 -->
      <img class="zxg-bottom-img" :src="bgImg" alt="" />
    </template>
  </div>
</template>

<script>
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import BetterweWxApi from '@/components/wx/control.js'
import Vue from 'vue'
import { Overlay } from 'vant'
Vue.use(Overlay)

/** 综训馆目标内页（后台 APP 链接生成器配置，2026-09-29 定）：APP 首页「综训馆」TAB。
 *  来源链接：https://btvue.gymcity.com.cn/app-download?toAppPath=%2Fhome%3FappLinkUseTypeId%3D4%26appRouterPagesId%3D21%26appRouterId%3D1257%26pageTag%3D0%26pageChildType%3D7 */
const TO_APP_PATH =
  '/home?appLinkUseTypeId=4&appRouterPagesId=21&appRouterId=1257&pageTag=0&pageChildType=7'
/** APP 自定义 scheme（与 app-download 一致）：微信外浏览器拉起已安装 APP */
const SCHEME_PREFIX = 'betterwe://deepLink/?newPath='
/** 设计稿切图（下半：APP 首页 mockup + 弧形过渡橙色区 + betterWE星球 logo） */
const BG_IMG =
  'https://gympic.gymcity.com.cn/uploads-add/202609/btweSport-scan-result-download-bg'
/** 渠道定制背景图：URL 带 sfrom=xxx 且命中 key 时整页展示对应背景图（渠道 UI）；
 *  不带 sfrom 或未命中时走默认 UI。新增渠道在此加一行即可（值为该渠道背景图 CDN 地址）。
 *  例：hrb: 'https://gympic.gymcity.com.cn/uploads-add/202610/xxx-channel-bg' */
const CHANNEL_BG_MAP = {
  InternalPurchase: 'https://gympic.gymcity.com.cn/uploads-add/202610/2026-10-21-app-download-bg-zxg',
  zxg: 'https://gympic.gymcity.com.cn/uploads-add/202610/zxg-app-download-kv'
}
/** 渠道定制 APP 落地页：URL 带 sfrom=xxx 且命中 key 时优先使用该内页（优先于 toAppPath 参数）。
 *  新增渠道在此加一行即可（值为后台 APP 链接生成器产出的内页路径）。 */
const CHANNEL_TO_APP_PATH_MAP = {
  InternalPurchase:
    '/home?appLinkUseTypeId=4&appRouterPagesId=21&appRouterId=1257&pageTag=0&pageChildType=5'
}

export default {
  name: 'zxg-scan-entry',
  components: { WxOpenLaunchApp },
  data() {
    return {
      showOpen: false, // 微信内下载未触发时的「浏览器打开」引导图
      isWeiXin: false,
      isMini: false,
      isAndroid: false,
      isIOS: false,
      bgImg: BG_IMG
    }
  },
  computed: {
    /** URL 上的渠道参数（?sfrom=xxx），无则 'default'（同 app-download） */
    sfrom() {
      return this.$route.query.sfrom || 'default'
    },
    /** 命中渠道时返回对应背景图，未命中/不带渠道返回 ''（走默认 UI） */
    channelBgImg() {
      return CHANNEL_BG_MAP[this.sfrom] || ''
    },
    /** APP 落地页：sfrom 命中渠道时用渠道内页；否则链接带 ?toAppPath= 就按它跳；
     *  都未命中则兜底综训馆默认内页 */
    toAppPath() {
      return (
        CHANNEL_TO_APP_PATH_MAP[this.sfrom] ||
        this.$route.query.toAppPath ||
        TO_APP_PATH
      )
    },
    /** 渠道 APK 包地址（同 app-download，sfrom 有值时下对应渠道包） */
    androidDownloadUrl() {
      const channel = this.$route.query.sfrom || 'BETTERWE'
      return (
        'https://gymvue.gymcity.com.cn/apk/betterWE_channel_' + channel + '.apk'
      )
    },
    /** sfrom 有值时走带渠道号（ct 归因参数）的 AppStore 链接，否则默认链接（同 app-download） */
    iosAppstoreUrl() {
      const defaultUrl = 'https://apps.apple.com/cn/app/id1578889450'
      const channelUrl =
        'https://apps.apple.com/app/apple-store/id1578889450?pt=123007243&ct=' +
        this.sfrom +
        '&mt=8'
      return this.$route.query.sfrom ? channelUrl : defaultUrl
    },
    /** 页面曝光埋点文案（同 app-download） */
    bgText() {
      return 'BG_APP_DOWNLOAD' + (this.sfrom ? '_' + this.sfrom : '')
    },
    /** 下载点击埋点文案（同 app-download） */
    clickText() {
      return 'CLICK_APP_DOWNLOAD' + (this.sfrom ? '_' + this.sfrom : '')
    },
    /** 美团直播预约渠道：微信鸿蒙端不拉起APP，中转到公众号H5活动页（同 app-download） */
    isMeiTuanJump() {
      return this.sfrom === 'MeiTuanReminder' && this.isWeiXinHarmony()
    }
  },
  created() {
    // 美团直播预约渠道：微信鸿蒙端不拉起APP，直接中转到公众号H5活动页（同 app-download）
    if (this.isMeiTuanJump) {
      this.$http._newToVueH5Url('activity-mt-live')
      return
    }
    this.checkPhone()
    this.isWeiXin =
      navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ? true : false
    try {
      wx.miniProgram.getEnv((res) => {
        this.isMini = res.miniprogram ? true : false
      })
    } catch (error) {
      this.isMini = false
    }
    // 分享信息（同 app-download）
    setTimeout(() => {
      this.setShare()
    }, 800)
  },
  mounted() {
    document.title = 'betterwe星球综训馆'
    // 页面曝光埋点（同 app-download）
    this.$buryPoint('APP_DOWNLOAD_SHOW', {
      from: this.sfrom
    })
    // 美团直播预约渠道：created 已中转到 H5 活动页，此处阻断拉起 APP 的逻辑
    if (this.isMeiTuanJump) {
      return
    }
    // 微信外（手机浏览器）：进页自动尝试一次 scheme 拉起（已装直达，未装静默失败走按钮/下载）
    if (!this.isWeiXin && !this.isMini) {
      this.openApp()
    }
  },
  methods: {
    // 环境判断（同 app-download）：iphone/mac 按 iOS，其余（含安卓/PC）一律按安卓走 APK 下载
    checkPhone() {
      const agent = navigator.userAgent || navigator.vendor || window.opera
      if (agent != null) {
        const agentName = agent.toLowerCase()
        if (/iphone/i.test(agentName) || /macintosh|mac os x/i.test(agentName)) {
          this.isIOS = true
        } else {
          this.isAndroid = true
        }
      }
    },
    // 是否是微信鸿蒙端（鸿蒙版微信 UA 带 OpenHarmony/ArkWeb 标识，不含 Android）
    isWeiXinHarmony() {
      const ua = navigator.userAgent.toLowerCase()
      return (
        ua.indexOf('micromessenger') > -1 &&
        (ua.indexOf('openharmony') > -1 ||
          ua.indexOf('harmonyos') > -1 ||
          ua.indexOf('arkweb') > -1)
      )
    },
    // 分享（同 app-download）
    setShare() {
      const share = {
        link: location.href,
        title: '在betterWE星球吃练结合收获好身材',
        desc: '已帮助100w+人成功逆袭，你也快来试试！',
        imgUrl: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_logo.png'
      }
      BetterweWxApi.setShareData(share, share)
    },
    // 微信外：scheme 拉起（未安装时无感知失败，用户走「下载」按钮）
    openApp() {
      location.href = `${SCHEME_PREFIX}${encodeURIComponent(this.toAppPath)}`
    },
    toUrl(index) {
      const routes = ['/agreement', '/privacy-agreement']
      this.$router.push(routes[index])
    },
    /* 点击下载按钮（同 app-download）：埋点后进入下载流程 */
    downloadApp() {
      this.$buryPoint('APP_DOWNLOAD_CLICK', {
        from: this.sfrom
      })
      this._doDownload()
    },
    async _doDownload() {
      if (this.isMini) {
        this.$dialog.alert({
          title: '提示',
          message: '请前往手机应用市场搜索“betterWE星球”下载安装'
        })
        return
      }
      if (this.isIOS) {
        // IOS 直接跳转App Store（逻辑不变）
        window.location.href = this.iosAppstoreUrl
      } else if (this.isAndroid) {
        // 安卓 + 微信内：微信拦截 APK 下载，直接弹「右上角浏览器打开」引导图
        // （不再走 downApp 中转，免去 3s 后才提示的等待）
        if (this.isWeiXin) {
          this.showOpen = true
          return
        }
        // 安卓包下载地址：链接带 getOssurl 时优先走接口取包，否则本地探测渠道包
        if (this.$route.query.getOssurl !== undefined) {
          const url = await this.getOssurl()
          this.downloadApk(url || (await this.getApk()))
        } else {
          this.downloadApk(await this.getApk())
        }
      } else {
        this.$toast('暂不支持，敬请期待~')
      }
    },
    // 渠道包存在（headFile 探测通过）则下渠道包，否则兜底默认 BETTERWE 包（同 app-download）
    async getApk() {
      let url = 'https://gymvue.gymcity.com.cn/apk/betterWE_channel_BETTERWE.apk'
      try {
        const res = await this.$http.headFile(this.androidDownloadUrl)
        if (res) {
          url = this.androidDownloadUrl
        }
      } catch (error) {
        // 获取失败时使用默认下载地址
      }
      return url
    },
    // 接口获取下载地址（链接带 getOssurl 参数时启用，同 app-download）
    async getOssurl() {
      const url =
        'https://app-toolkit-t.betterwestar.com/api/v1/public/download/com.wegymer.betterwe/' +
        encodeURIComponent(this.sfrom)
      try {
        const res = await this.$http.commonGet(url)
        if (res && res.data && res.data.code === 200) {
          return res.data.data && res.data.data.downloadUrl
        }
      } catch (error) {
        // 获取接口下载地址失败时使用默认下载地址
      }
    },
    /* 安卓下载（同 app-download）：微信内走 downApp 中转（触发微信底部「在浏览器打开」
       引导条，免手动右上角），微信外直接 a.download */
    downloadApk(url) {
      if (this.isWeiXin) {
        const a = document.createElement('a')
        url = `https://api3t.gymcity.com.cn/member/downApp?down_url=${encodeURIComponent(
          url
        )}`
        a.href = url
        document.body.appendChild(a)
        a.click()
        setTimeout(() => {
          document.body.removeChild(a)
        }, 500)
        // 3s 后页面仍可见 = 下载未触发（微信拦截），弹出「右上角浏览器打开」引导图
        setTimeout(() => {
          if (document.visibilityState === 'visible') {
            this.showOpen = true
          }
        }, 3000)
      } else {
        const a = document.createElement('a')
        let filename = url.split('/')
        filename = filename[filename.length - 1]
        filename = filename.split('.')[0]
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        setTimeout(() => {
          document.body.removeChild(a)
        }, 500)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

/** 品牌橙（按稿取色：副文案强调字 / 下载按钮实心底 / 打开按钮描边字同色） */
$zxg-brand: #ff9018;

.zxg-scan-entry {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  background: #fff;

  .ad-open {
    width: 100vw;
    position: absolute;
    top: 0;
    right: 1vw;
  }

  /* —— 上半：标题 + 副文案 + 双按钮（稿：白底居中排布） —— */
  .zxg-top {
    width: 100%;
    padding-top: vw(56);
    text-align: center;
  }

  .zxg-title {
    font-size: vw(20);
    font-weight: 600;
    color: #1f2021;
    line-height: vw(28);
  }

  .zxg-desc {
    margin-top: vw(16);
    font-size: vw(14);
    color: #1f2021;
    line-height: vw(24);

    p {
      margin: 0;
    }

    .zxg-app-name {
      color: $zxg-brand;
    }
  }

  .zxg-btns {
    margin-top: vw(28);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: vw(12);
  }

  .zxg-btn {
    position: relative;
    width: vw(120);
    height: vw(44);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: vw(22);
    font-size: vw(15);
    font-weight: 500;
    box-sizing: border-box;
  }

  .zxg-btn-open {
    background: #fff;
    color: $zxg-brand;
    border: 1px solid $zxg-brand;
  }

  .zxg-btn-download {
    background: $zxg-brand;
    color: #fff;
  }

  /* —— 下半：设计稿切图（mockup + 弧形过渡橙色区 + logo），宽 100% 置底 —— */
  .zxg-bottom-img {
    width: 100%;
    display: block;
    margin-top: auto; // 视口富余时贴底，上半自然居上
  }

  /* —— 渠道 UI：结构与样式同 app-download（整页背景图 + 底部固定双按钮 + 协议入口）。
     flex 列布局 + align-items:center 必须保留：fixed 按钮 left/right 为 auto 时取静态
     位置（flex 交叉轴居中），这是按钮水平居中的机制，与 app-download 根容器一致 —— */
  .zxg-channel {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .zxg-channel-container {
      position: relative;
      min-height: 100vh;
    }

    .zxg-channel-bg {
      width: 100%;
      box-sizing: border-box;
      display: block;
    }

    .ad-tips {
      position: absolute;
      left: 0px;
      bottom: 0px;
      width: 100%;
      padding: 10px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: vw(12);
      color: rgba($color: #000000, $alpha: 1);

      .t-btn {
        position: relative;
      }

      .t-line {
        width: 0.3vw;
        height: 2.9vw;
        background-color: rgba($color: #000000, $alpha: 0.3);
        margin: 0 2.7vw;
      }
    }

    .ad-btn {
      width: 327px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #1f2021;
      box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.12),
        0px 2px 6px 0px rgba(0, 0, 0, 0.14);
      border-radius: 25px;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      position: fixed;
      z-index: 88;
      @include fixedBottom(40px);

      img {
        width: vw(27);
        margin-right: vw(12);
        margin-top: vw(-2);
      }
    }

    .ad-btn-have {
      @include fixedBottom(100px);
    }
  }
}
</style>
